export default __webpack_public_path__ + "src/images/hotspot-c09463.png";